/**
 * @generated SignedSource<<d9d01d5c3af575598f8e40708d862eaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelineLineProjectFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PipelineLineLastRunFragment" | "pipelineHeadFragment">;
  readonly " $fragmentType": "PipelineLineProjectFragment";
};
export type PipelineLineProjectFragment$key = {
  readonly " $data"?: PipelineLineProjectFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PipelineLineProjectFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PipelineLineProjectFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pipelineHeadFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PipelineLineLastRunFragment"
    }
  ],
  "type": "ProjectRest",
  "abstractKey": null
};

(node as any).hash = "57352c3a3c1c0b11885154fd48a39b0e";

export default node;
